'use client';

import { Carousel } from '@asurion-core/aui-react-carousel';
import { useEffect, useState } from 'react';

export * from '@asurion-core/aui-react-carousel';

export function AuiCarousel(props: any) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient ? <Carousel {...props} /> : null;
}
